import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import ImageKit from 'components/common/Image';
import DynamicIcon from 'hooks/useIconDynamic';

const useStyle = makeStyles((theme) => ({
	keepaLink: {
		color: theme.palette.warning.main,
		'&:hover': {
			color: theme.palette.warning['400'],
		},
	},
	borderRadiusCustom: {
		borderRadius: theme.shape.large,
		padding: '5rem',
		textAlign: 'center',
	},
	describeRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		[theme.breakpoints.between('xs', 'sm')]: {
			minWidth: '13rem ',
		},
	},
	describeColumn: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	tagNew: {
		backgroundColor: theme.palette.info[700],
		borderRadius: theme.shape.large,
		marginRight: '0.8rem',
		width: '2.7rem',
		height: '1.8rem',
		display: 'flex',
		padding: '0.8rem 2rem',
		justifyContent: 'center',
		alignItems: 'center',
		aspectRatio: '16/9',
		[theme.breakpoints.between('xs', 'sm')]: {
			fontSize: '1rem !important',
			padding: '0.4rem',
		},
	},
}));

const DescriptionKit = (props) => {
	const classes = useStyle();
	const {
		direction,
		title,
		subTitle,
		textAlign,
		icon,
		fontStyleSubTitleProps,
		fontStyleTitleProps,
		tagNew,
		alignItems,
		store,
		iconImage,
		styleIcon,
		iconElement,
		justifyContent,
		iconExternal,
		...others
	} = props;

	return (
		<Box>
			{direction === 'row' && (
				<Box className={classes.describeRow} alignItems={alignItems} justifyContent={justifyContent}>
					{iconImage && (
						<Box style={styleIcon} width={styleIcon.width} height={styleIcon.height}>
							<ImageKit src={iconImage} alt="icon" />
						</Box>
					)}
					{icon && <i className={icon} style={styleIcon} />}
					{iconElement && <>{iconElement}</>}
					{iconExternal && (
						<Box mr="1.6rem">
							<DynamicIcon
								iconName={iconExternal}
								innerProps={{
									size: '25',
									color: '#9B9BC4',
									variant: 'Outline',
								}}
							/>
						</Box>
					)}
					{/* {icon && (
						<Box style={styleIcon} position="relative" width={styleIcon.width} height={styleIcon.height}>
							<ImageKit alt="logo" src={icon} />
						</Box>
					)} */}

					<Box className={classes.describeColumn} alignItems={alignItems}>
						{tagNew ? (
							<>
								<Box display={'flex'} justifyContent="center" alignItems="baseline" flexDirection={'row'}>
									<Typography variant={others.variantTitle} style={fontStyleTitleProps}>
										{title}
									</Typography>

									<Box className={classes.tagNew}>جدید</Box>
								</Box>
								<Typography variant={others.variantSubTitle} style={fontStyleSubTitleProps}>
									{subTitle}
								</Typography>
							</>
						) : (
							<>
								<Typography variant={others.variantTitle} style={fontStyleTitleProps}>
									{title}
								</Typography>
								<Typography variant={others.variantSubTitle} style={fontStyleSubTitleProps}>
									{subTitle}
								</Typography>
							</>
						)}
					</Box>
				</Box>
			)}

			{direction === 'column' && (
				<Box className={classes.describeColumn} alignItems={alignItems} justifyContent={justifyContent}>
					{iconImage && (
						<Box style={styleIcon} width={styleIcon.width} height={styleIcon.height}>
							<ImageKit src={iconImage} alt="icon" />
						</Box>
					)}
					{icon && <i className={icon} style={styleIcon} />}
					{iconElement && <>{iconElement}</>}
					{iconExternal && (
						<Box mr="1.6rem">
							<DynamicIcon
								iconName={iconExternal}
								innerProps={{
									size: '25',
									color: '#9B9BC4',
									variant: 'Outline',
								}}
							/>
						</Box>
					)}
					<Typography variant={others.variantTitle} style={fontStyleTitleProps}>
						{title}
					</Typography>
					<Typography
						textAlign={textAlign}
						variant={others.variantSubTitle}
						style={fontStyleSubTitleProps}
						display="flex"
					>
						{store && <Typography> فروشگاه</Typography>}
						{subTitle}
					</Typography>
				</Box>
			)}
		</Box>
	);
};

export default DescriptionKit;
